<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent: 00em;">Dan Pinckney is a retired military NCO with a combined service of 20 years of active service and another ten years as a military contractor working with inner-city youth in different schools. While on active duty, he attended college taking classes at different colleges in different states, until he was able to graduate with honors from Stonehill College in Easton, MA. After retiring, he obtained a teaching certificate in history, then applied and was selected to perform as a Junior ROTC instructor and assigned to a city high school.</p><br/>
<p style="text-indent: 00em;">While there, he used his skill and experience to encourage students to remain in school and even become interested in subjects like history and English, encouraging all his students to achieve what they thought was impossible, staying in school and graduating. Many, in fact, became interested in English and several are now teachers in different states.</p><br/>
<p style="text-indent: 00em;">However, it was while he was involved with the Air Force that he fell in love with stories and putting those ideas on paper. To date, he has had one self-published novel, <em>Journey to the Catskills</em> which is receiving more interest from publishing houses for possible remarketing, and is currently in negotiations to create a website to advertise his current and future works.</p><br/>
<p style="text-indent: 00em;">Dan Pinckney lives with his wife and kids in Rhode Island.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?ddfa1dc2